"use client";

import { displayValue } from "../OtherBetsDropdown";

import { useOddsTrend } from "@/hooks/useOddsTrend";

const OKGoalOddEvenOdds = ({ goalOddEvenOdds }) => {
  const odds =
    Array.isArray(goalOddEvenOdds) && goalOddEvenOdds.length > 0
      ? goalOddEvenOdds[0]
      : {};

  if (!odds?.single && !odds?.double) return null;

  const OddItem = ({ title, value, trend }) => {
    const { isUp, isDown, animating, animationClass, successValueColorClass, borderBgClass } = useOddsTrend(trend, value);
    
    return (
      <div
        className={`market-line relative flex items-center justify-between border rounded-lg h-[38px] px-2.5 mb-1 md:min-h-[48px] md:h-auto md:pl-3.5 md:pr-4 md:mb-3 cursor-pointer kbv-shadow-subtle transition-colors overflow-hidden ${borderBgClass} ${animationClass} ${animating ? "" : "hover:border-[var(--theme-primary)] hover:bg-[var(--theme-accent)]"}`}
      >
        {isUp && animating && (
          <div className="absolute left-[2px] top-[2px] z-10 animate-triangle-flash kbv-triangle-up-anim" />
        )}
        {isDown && animating && (
          <div className="absolute right-[2px] bottom-[2px] z-10 animate-triangle-flash kbv-triangle-down-anim" />
        )}

        <span className="odd-title md:text-[16px] text-[14px] kbv-text-main">
          {title}
        </span>

        {value ? (
          <span className="odd-icon">
            <div>
              <div className={`newValue positive text-[16px] font-semibold ${successValueColorClass}`}>
                {displayValue(value)}
              </div>
            </div>
          </span>
        ) : (
          <span className="text-[16px] kbv-text-main font-semibold">-</span>
        )}
      </div>
    );
  };

  return (
    <div>
      <div className="match-score px-0">
        <div className="grid grid-cols-2 gap-x-[15px]">
          <OddItem title="Lẻ" value={odds?.single} trend={odds?.singleTrend} />
          <OddItem title="Chẵn" value={odds?.double} trend={odds?.doubleTrend} />
        </div>
      </div>
    </div>
  );
};

export default OKGoalOddEvenOdds;